import { Injectable } from '@angular/core';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { BistrackConfig } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';
import { IEpShellMenuPanelModel } from '@epicor/kinetic';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaDashboardService {

  folderdata: any;
  menus: any[] = [];
  parentFolder: any;
  subFolder: any;
  isFolderExist = false;
  public treeNodes: IEpShellMenuPanelModel[] = [];
  dashboardId: number;
  storeUrl: string;

  constructor(private client: FieldAgentClient, private faService: EpbtFieldAgentService) { }

  LoadDashboardsMenu(webTrackUser, subscribe: (menus: any[]) => void) {
    // this.faService.getBisTrackSetting((bisTrackSetting: any) => {
    //   this.faService.getWebTrackUser((webTrackUser: any) => {
    this.client.getDashboardsForUser(webTrackUser).subscribe(res => {
      if (res && res.length != 0) {
        this.folderdata = res.filter(item => item.bisTrackCloudAccess);
        subscribe(this.prepareDataForMenu(this.folderdata));
      }
    });
    //   });
    // });
  }

  prepareFolders(folders, index): string {
    let folder = folders[0];
    for (let i = 1; i <= index; i++) {
      folder += '/' + folders[i];
    }
    return folder;
  }

  prepareDataForMenu(folders: any[]): any {
    const mainParent = 'Dashboards';
    this.menus.push({
      id: mainParent,
      parentId: '',
      link: '',
      caption: mainParent,
      // icon: 'mdi mdi-package mdi-18px',
      folder: true,
    });

    if (folders && folders.length > 0) {
      folders.forEach(item => {
        if (item.groupName == '') {
          this.menus.push({
            id: item.dashboardID,
            parentId: mainParent,
            // link: '/home/dashboarddetails',
            link: '/home',
            caption: item.name,
            type: 'Dashboard'
            // icon: 'mdi mdi-user mdi-18px',
          });
        } else {
          const folderNames = item.groupName.split('\\');
          if (folderNames && folderNames.length > 1) {
            let isItem = false;
            for (let index = 1; index <= folderNames.length; index++) {
              this.subFolder = mainParent + '/' + this.prepareFolders(folderNames, folderNames.length - index);
              this.parentFolder = (folderNames.length - index) != 0 ? mainParent + "/" + this.prepareFolders(folderNames, (folderNames.length - index) - 1) : mainParent;

              this.isFolderExist = this.menus.findIndex(x => x.id == this.subFolder) > 0 ? true : false;
              console.log(this.isFolderExist);
              if (!this.isFolderExist) {
                this.menus.push({
                  id: this.subFolder,
                  parentId: this.parentFolder,
                  link: '',
                  caption: folderNames[folderNames.length - index],
                  // icon: 'mdi mdi-package mdi-18px',
                });
                if (!isItem) {
                  this.menus.push({
                    id: item.dashboardID,
                    parentId: this.subFolder,
                    // link: '/home/dashboarddetails',
                    link: '/home',
                    caption: item.name,
                    type: 'Dashboard'
                    // icon: 'mdi mdi-user mdi-18px',
                  });
                  isItem = true;
                }
              } else {
                if (!isItem) {
                  this.menus.push({
                    id: item.dashboardID,
                    parentId: this.subFolder,
                    // link: '/home/dashboarddetails',
                    link: '/home',
                    caption: item.name,
                    type: 'Dashboard'
                    // icon: 'mdi mdi-user mdi-18px',
                  });
                  isItem = true;
                }
              }
            }
          } else {
            this.parentFolder = mainParent;
            this.subFolder = mainParent + '/' + folderNames[folderNames.length - 1];
            this.isFolderExist = this.menus.findIndex(x => x.id == this.subFolder) > 0 ? true : false;
            if (!this.isFolderExist) {
              this.menus.push({
                id: this.subFolder,
                parentId: this.parentFolder,
                link: '',
                caption: folderNames[folderNames.length - 1],
                // icon: 'mdi mdi-package mdi-18px',
              });
              this.menus.push({
                id: item.dashboardID,
                parentId: this.subFolder,
                // link: '/home/dashboarddetails',
                link: '/home',
                caption: item.name,
                type: 'Dashboard'
                // icon: 'mdi mdi-user mdi-18px',
              });
            } else {

              this.menus.push({
                id: item.dashboardID,
                parentId: this.subFolder,
                // link: '/home/dashboarddetails',
                link: '/home',
                caption: item.name,
                type: 'Dashboard'
                // icon: 'mdi mdi-user mdi-18px',
              });
            }
            // }

          }
        }
      });
    }
    console.log('menus', this.menus);
    return this.menus;
  }

  // This method is used for Store Module
  getStoreUrl(webtrackuser, subscribe: (storeUrl) => void) {
    if (webtrackuser) {
      this.client.getWebSiteRoot(webtrackuser).subscribe(res => {
        if (res) {
          this.storeUrl = res;
          subscribe(this.storeUrl);
          //  window.open(url);
        }
      });
    }
  }
}
